import http from "@/services/api/http";

export default {
  getList() {
    return http.get("common/settings");
  },
};
